import { createSelector, createSlice } from '@reduxjs/toolkit';
import { FormikValues } from 'formik';
import { RootState } from 'store/store';

const initialState: { formData: FormikValues } = {
  formData: {},
};

const dataFormSlice = createSlice({
  name: 'dataForm',
  initialState,
  reducers: {
    setDataForm: (state, action) => {
      state.formData = action.payload;
    },
    clearDataForm: (state) => {
      state.formData = {};
    },
  },
});

export const { setDataForm, clearDataForm } = dataFormSlice.actions;

export default dataFormSlice.reducer;

const selectStore = (store: RootState) => store.dataForm;

export const selectDataForm = createSelector([selectStore], (store) => store.formData);
